import { render, staticRenderFns } from "./MonthlyInspectionsSituations.vue?vue&type=template&id=c50cf1f6&scoped=true&"
import script from "./MonthlyInspectionsSituations.vue?vue&type=script&lang=ts&"
export * from "./MonthlyInspectionsSituations.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyInspectionsSituations.vue?vue&type=style&index=0&id=c50cf1f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50cf1f6",
  null
  
)

export default component.exports